import Vue from 'vue'
import Router from 'vue-router'

import { authGuard } from './authGuard'

import MainLayout from '@/layouts/MainLayout'
import LandingPage from '@/views/LandingPage'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      beforeEnter: authGuard,
      component: MainLayout,
      children: [
        {
          path: '',
          component: LandingPage,
          name: 'landing-page'
        }
      ]
    }
  ],
  mode: 'history'
})

export default router
